import React from "react";

interface DateBadgeProps {
  dateString: string | null;
}

export const DateBadge: React.FC<DateBadgeProps> = ({ dateString }) => {
  const formatDate = (str: string | null) => {
    if (!str) return "N/A";
    const date = new Date(str);
    if (isNaN(date.getTime())) return "N/A";
    const day = String(date.getDate()).padStart(2, "0");
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month}, ${year}`;
  };

  return (
    <div className="flex items-center gap-2 px-3 py-1.5 border border-gray-200 rounded-xl bg-white text-gray-700 text-sm w-fit shadow-sm">
      <svg className="w-4 h-4 text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
      </svg>
      <span className="font-semibold text-gray-700">{formatDate(dateString)}</span>
    </div>
  );
};
